import { FlexBox, HeaderText } from '@make-software/cspr-design';
import styled from 'styled-components';

export const HeaderContainer = styled(FlexBox)<{ withContractSettingsModal: boolean }>(
  ({ theme, withContractSettingsModal }) =>
    theme.withMedia({
      padding: ['24px 0 24px', '32px 0 24px'],
      flexDirection: [withContractSettingsModal ? 'row' : 'column', 'row'],
      justifyContent: [withContractSettingsModal ? 'space-between' : 'center', 'space-between'],
      alignItems: [withContractSettingsModal ? 'center' : 'flex-start', 'center'],
      gap: ['24px', '16px'],
    })
);

export const Title = styled(HeaderText)(({ theme }) =>
  theme.withMedia({ fontSize: ['24px', '32px'], lineHeight: ['32px', '40px'] })
);
